import React, { FunctionComponent } from 'react';
import { Col, Row } from 'react-flexbox-grid';

import '../styles.scss';

export type StepRowProps = {
  stepIndex: number;
  stepNumber?: number;
  stepTitle: string;
  children?: React.ReactNode;
};

const StepRow: FunctionComponent<StepRowProps> = ({ stepIndex, stepNumber = stepIndex, stepTitle, children }) => {
  return (
    <Col
      key={`finalisation-step-${stepIndex}`}
      xs={12}
      md={12}
      lg={12}
      className="finalisation-card-row bg-white px-8 py-6 mb-0 border-x border-t border-solid border-grey-100 rounded-none first:rounded-t-lg last:rounded-b-lg last:border-b"
    >
      <Row className="finalisation-card-label font-semibold text-xl pb-[0.625rem]">
        <Col xs={12} md={12} lg={12}>
          <span
            className="inline-flex text-center leading-5 -ml-2 w-6 h-6 border border-solid border-grey-400 rounded-full text-grey-400 bg-white justify-center items-center"
            data-test={`label_step${stepIndex}_number`}
          >
            {stepNumber}
          </span>
          <div className="inline-block pl-4" data-test={`label_step${stepIndex}_title`}>
            {stepTitle}
          </div>
        </Col>
      </Row>
      <Row
        className="finalisation-card-content ml-[1.625rem] text-sm pb-0"
        data-test={`label_step${stepIndex}_subTitle`}
      >
        {children}
      </Row>
    </Col>
  );
};

export default StepRow;
